module.exports = __webpack_public_path__ + "i18n/ru.d6f0ee2d624e2b34da8fbe35081382f0.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1547
// module chunks = 60